export { default as Document } from './document';
